import * as React from 'react';
import moment from "moment";

const DateFormat = "YYYY/MM/DD";

const InfoTable = (props) => {

    function renderRowData(info) {
        return info.map((row, index) => {
            return <tr key={index}>
                <td className="info-date">{row.EntryDt ? moment(row.InfoDt).format(DateFormat) : ""}</td>
                <td className="info-message">{row.InfoMassage}</td>
            </tr>
        })
    }

    function renderTable(props) {
        return (
            <div className="info-container">
                <table className="info-table">
                    <tbody>
                        {renderRowData(props.data)}
                    </tbody>
                </table>
            </div>
        )
    }

    return (
        <div>
            {renderTable(props)}
        </div>
    )
}

export default InfoTable;


// WEBPACK FOOTER //
// ./components/common/infotable/index.jsx